import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {StickyPopover} from 'asax-common';

@Component({
  selector: 'asax-frequency-view-frequency-view-chart-splat-popover',
  templateUrl: './frequency-view-chart-splat-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrequencyViewChartSplatPopoverComponent implements OnChanges {
  @ViewChild('stickyPopover', {static: true}) stickyPopover: StickyPopover;

  @Input() splat: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.splat) {
      this.onSplat();
    }
  }

  close(): void {
    this.stickyPopover?.close();
  }

  closeWithTimeout(): void {
    this.stickyPopover?.closeWithTimeout();
  }

  private onSplat(): void {
    if (this.splat) {
      this.stickyPopover?.open();
    } else {
      this.stickyPopover?.close();
    }
  }
}
